import Box from '@cavilha/box';
import Rating from '@cavilha/rating';
import { useListFilter } from 'hooks/algolia/useListFilter';
import { useState } from 'react';
import { connectRange } from 'react-instantsearch-dom';

const RatingMenu = connectRange(
  ({ refine, count: refinementCount, currentRefinement: { min } }) => {
    const [activeIndex, setActiveIndex] = useState('');

    const handleOnClick = index => {
      if (index !== activeIndex) {
        setActiveIndex(index);
      } else {
        setActiveIndex('');
        refine({ min: 1 });
      }
    };

    const initialCount = [
      { value: '0', count: 0 },
      { value: '1', count: 0 },
      { value: '2', count: 0 },
      { value: '3', count: 0 },
      { value: '4', count: 0 },
      { value: '5', count: 0 },
    ];

    const { trackListFilter } = useListFilter();

    const refinementCountIndexed = refinementCount.reduce((prevVal, item) => {
      const { value } = item;
      return { ...prevVal, [value]: item };
    }, {});

    const ratingsToShow = initialCount
      .filter(rating => {
        return rating.value !== '0' && rating.value !== '5';
      })
      .map(item => {
        const { value } = item;
        const { count } =
          value in refinementCountIndexed ? refinementCountIndexed[value] : { count: 0 };

        return { ...item, count };
      });

    ratingsToShow.sort(({ value: valueA }, { value: valueB }) => Number(valueB) - Number(valueA));

    return (
      <ul>
        {ratingsToShow.map(({ value, count }) => {
          const valueNumber = Number(value);
          const isActive = valueNumber === min;
          const elementPosition = ratingsToShow.findIndex(item => item.value === value) + 1;
          return (
            <a
              role="button"
              aria-label={`${value} e acima`}
              tabIndex={valueNumber}
              key={value}
              onClick={event => {
                event.preventDefault();
                if (!isActive) {
                  trackListFilter({
                    typeName: 'Avaliações',
                    elementPosition,
                    elementName: `${value} e acima`,
                  });
                  refine({ min: value });
                } else {
                  refine({});
                }
              }}
              // handleOnClick(index);
            >
              <Box css={{ my: '$small3' }} data-value={valueNumber} data-count={count}>
                <Rating
                  mode="default"
                  counter={count}
                  active={isActive}
                  ratioValue={valueNumber}
                  type="filterAverage"
                />
              </Box>
            </a>
          );
        })}
      </ul>
    );
  }
);

export default RatingMenu;
